import { useEffect, useState } from 'react'
import { Avatar, Card, Grid, MenuItem, Paper, TextField, Container, InputBase, IconButton, Box, Divider } from '@mui/material'
import { makeStyles } from '@material-ui/core'
import MessageError from '../../messages/messageError'
import apiCNP from '../../services/apiCNP'
import api from '../../services/api'
import { useSelector } from 'react-redux'
import MessageSuccess from '../../messages/messageSuccess'
import HeaderSession from '../../utils/headerSession'
import { useNavigate } from 'react-router-dom';
import RegisterAccess from '../../utils/registerAccess'
import LoadingShort from '../../load/loadingShort';
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ButtonLeft from '../../utils/buttonLeft'

const useStyles = makeStyles((theme) => ({
    root: {
        alignItems: 'flex-start',
    },

    gridItem: {
        padding: 10,
    },

    card: {
        padding: '30px',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fafafa',
    },

    searchContainer: {
        width: '100%',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        display: 'flex',
        padding: '12px 16px',
        backgroundColor: '#fff',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
        marginBottom: '28px',
        '&:hover': {
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
        },
    },

    photoContainer: {
        border: '2px dashed #3e3d3f',
        borderRadius: '8px',
        padding: '16px',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        backgroundColor: '#fff',
        '&:hover': {
            borderColor: '#1976d2',
            backgroundColor: '#f5f5f5',
        },
    },

    sectionDivider: {
        margin: '24px 0',
        backgroundColor: '#e0e0e0',
    },

    sectionTitle: {
        fontSize: '13px',
        fontWeight: 700,
        color: '#1976d2',
        marginBottom: '20px',
        marginTop: '8px',
        textTransform: 'uppercase',
        letterSpacing: '0.8px',
    },

    textField: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#fff',
            borderRadius: '6px',
            transition: 'all 0.2s',
            '&:hover fieldset': {
                borderColor: '#1976d2',
            },
        },
    },
}))


export default function CadastroAdmin() {
    const navigate = useNavigate();
    const classes = useStyles()
    const [dadosAdmin, setDadosAdmin] = useState('');
    const [municipios, setMunicipios] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [messageSuccess, setMessageSuccess] = useState('');
    const [messageError, setErrorMessage] = useState('');
    const [load, setLoad] = useState(false);
    const user = useSelector(state => state.account.user);
    const [perfil, setPerfil] = useState('');
    const [search, setSearch] = useState("");

    const [departamentos, setDepartamentos] = useState([])
    const [perfils, setPerfils] = useState([]);
    const [seccoes, setSeccoes] = useState([]);

    useEffect(() => {
        api.get('/depatamentos')
            .then(res => {
                setDepartamentos(res.data.departamentos);
            }).catch(err => console.error('Erro ao carregar departamentos:', err));

        api.get('/seccoes')
            .then(res => {
                setSeccoes(res.data.seccoes);
            }).catch(err => console.error('Erro ao carregar secções:', err));

        api.get('/perfils')
            .then(res => {
                setPerfils(res.data.perfils);
            }).catch(err => console.error('Erro ao carregar perfis:', err));

    }, [])


    useEffect(() => {
        apiCNP.get('/provincias')
            .then(res => {
                setProvincias(res.data.provincias);
            }).catch(err => console.error('Erro ao carregar províncias:', err))
    }, [])

    function HandleChange(e) {

        e.target.files ?
            setDadosAdmin({ ...dadosAdmin, [e.target.name]: e.target.files[0] })
            :
            setDadosAdmin({ ...dadosAdmin, [e.target.name]: e.target.value })

        e.target.name === 'provincia' &&
            apiCNP.get(`/municipios-by-provincia/${e.target.value._id}`)
                .then(res => {
                    setMunicipios(res.data.municipios);
                }).catch(err => console.error('Erro ao carregar municípios:', err))
    }

    async function createAdmin() {
        const formData = new FormData();
        formData.append('dadosPessoaisId', dadosAdmin?._id ?? '');
        formData.append('foto', dadosAdmin?.foto ?? dadosAdmin.fotoURL);
        formData.append('nome', dadosAdmin?.nome ?? '');
        formData.append('numeroBI', dadosAdmin?.numeroBI ?? '');
        formData.append('email', dadosAdmin?.email ?? '');
        formData.append('tel1', dadosAdmin?.tel1 ?? '');
        formData.append('tel2', dadosAdmin?.tel2 ?? '');
        formData.append('genero', dadosAdmin?.genero ?? '');
        formData.append('provincia', dadosAdmin?.provincia.designacao ?? '');
        formData.append('municipio', dadosAdmin?.municipio.designacao ?? '');
        formData.append('bairro', dadosAdmin?.bairro ?? '');
        formData.append('rua', dadosAdmin?.rua ?? '');
        formData.append('userId', user?._id ?? '');
        formData.append('dataNascimento', dadosAdmin?.dataNascimento ?? '');
        formData.append('estadoCivil', dadosAdmin?.estadoCivil ?? '');
        formData.append('departamento', dadosAdmin?.departamento ?? '');
        formData.append('numeroAgente', dadosAdmin?.numeroAgente ?? '');
        formData.append('seccao', dadosAdmin?.seccao ?? '');
        formData.append('perfil', perfil?.perfil ?? dadosAdmin?.perfil);

        setLoad(true)
        setErrorMessage('')
        setMessageSuccess('')

        await api.post('/admin/register', formData)
            .then(res => {
                setLoad(false)
                setMessageSuccess(res.data.msg)
                navigate('/admin/lista-de-usuarios-administradores')

            }).catch(error => {
                setErrorMessage(error.response.data.message)
                setLoad(false)
            })
    }

    const searchDadosPessoais = async (e) => {
        e.preventDefault();
        setErrorMessage('')
        setLoad(true);
        try {
            const response = await api.post(`/dados-pessoais/search`, {
                search: search,
            });
            setDadosAdmin(response.data.dadosPessoais);
        } catch (error) {
            setErrorMessage(error?.response?.data.message);
        } finally {
            setLoad(false);
        }
    };

    return (
        <Container maxWidth="lg" style={{ paddingTop: '24px', paddingBottom: '40px' }}>
            <RegisterAccess page={'cadastro de admin'} />
            <HeaderSession title={'CADASTRO DE ADMINISTRADOR'} />

            <Card className={classes.card}>

                {messageSuccess && <MessageSuccess message={messageSuccess} />}
                {messageError && < MessageError message={messageError} />}

                <Box className={classes.searchContainer}>
                    <form
                        onSubmit={searchDadosPessoais}
                        style={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                        }}
                    >
                        <InputBase
                            sx={{ flex: 1 }}
                            size='small'
                            placeholder="Procurar por email, número de BI ou número de telefone"
                            inputProps={{ "aria-label": "Filtrar lista" }}
                            onChange={(e) => setSearch(e.target.value)}
                        />

                        <IconButton type="submit" aria-label="search" size="small" sx={{ color: '#1976d2' }}>
                            {load ? <LoadingShort text={''} /> : <SearchOutlinedIcon />}
                        </IconButton>
                    </form>
                </Box>

                <Grid container className={classes.root}>
                    <Grid xs={12} md={3} item className={classes.gridItem} >
                        <Paper className={classes.photoContainer}>
                            <label htmlFor="foto" style={{ cursor: 'pointer', display: 'block' }}>
                                {(dadosAdmin?.foto || dadosAdmin.fotoURL) ?
                                    <div style={{ padding: 8 }}>
                                        <Avatar style={{ width: '100%', height: 160, marginBottom: 12 }} variant="square" src={dadosAdmin.foto ? URL.createObjectURL(dadosAdmin?.foto) : dadosAdmin.fotoURL} title="Clique para alterar a imagem" />
                                        <p style={{ margin: '8px 0 0 0', fontSize: '12px', color: '#666', fontWeight: 500 }}>Clique para alterar</p>
                                    </div>
                                    :
                                    <div style={{ padding: 8 }}>
                                        <img style={{ height: 130, marginBottom: 12 }} src='/img/avatar/avatarRepresentante.svg' alt='avatar' title="Clique para carregar uma imagem" />
                                        <p style={{ margin: '8px 0 0 0', fontSize: '12px', fontWeight: 600, color: '#1976d2' }}>Carregar Foto</p>
                                    </div>
                                }
                                <input accept="image/png, image/jpg, image/jpeg" type="file" name="foto" id="foto" style={{ display: 'none' }} onChange={HandleChange} />
                            </label>
                        </Paper>
                    </Grid>

                    <Grid xs={12} md item className={classes.gridItem}>
                        <Box className={classes.sectionTitle}>Dados Pessoais</Box>
                        <TextField
                            type="text"
                            required
                            label="Nome"
                            fullWidth
                            size="small"
                            name="nome"
                            variant="outlined"
                            onChange={HandleChange}
                            value={dadosAdmin?.nome}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />

                        <TextField
                            style={{ marginTop: 16 }}
                            type="text"
                            required
                            label="Número de B.I"
                            fullWidth
                            size="small"
                            name="numeroBI"
                            variant="outlined"
                            onChange={HandleChange}
                            value={dadosAdmin?.numeroBI}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />

                        <Grid container className={classes.root} style={{ marginTop: '8px' }}>
                            <Grid xs={12} md item className={classes.gridItem}>
                                <TextField
                                    style={{ marginTop: 10 }}
                                    type="text"
                                    label="Departamento de:"
                                    select
                                    fullWidth
                                    size="small"
                                    name="departamento"
                                    variant="outlined"
                                    onChange={HandleChange}
                                    value={dadosAdmin?.departamento || ''}
                                    className={classes.textField}
                                >
                                    {departamentos.map((departamento) => (
                                        <MenuItem key={departamento.sigla} value={departamento.sigla}>
                                            {departamento.designacao}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>

                            <Grid xs={12} md item className={classes.gridItem}>
                                <TextField
                                    disabled={dadosAdmin.departamento === 'DCITMS'}
                                    style={{ marginTop: 10 }}
                                    type="text"
                                    label="Secção"
                                    select
                                    fullWidth
                                    size="small"
                                    name="seccao"
                                    variant="outlined"
                                    onChange={HandleChange}
                                    value={dadosAdmin?.seccao || ''}
                                    className={classes.textField}
                                >
                                    {seccoes.map((seccao) => (
                                        <MenuItem key={seccao._id} value={seccao?.designacao}>
                                            {seccao?.designacao}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>

                            <Grid xs={12} md item className={classes.gridItem}>
                                <TextField
                                    style={{ marginTop: 10 }}
                                    type="text"
                                    label="Perfil"
                                    select
                                    fullWidth
                                    size="small"
                                    name="perfil"
                                    variant="outlined"
                                    onChange={HandleChange}
                                    className={classes.textField}
                                >
                                    {perfils.map((perfil) => (
                                        <MenuItem onClick={() => setPerfil(perfil)} key={perfil.designacao} value={perfil.designacao}>
                                            {perfil.designacao}
                                        </MenuItem>
                                    ))}

                                </TextField>
                            </Grid>

                            <Grid xs={12} md item className={classes.gridItem}>
                                <TextField
                                    style={{ marginTop: 10 }}
                                    type="number"
                                    required
                                    label="Número de Agente"
                                    fullWidth
                                    size="small"
                                    name="numeroAgente"
                                    variant="outlined"
                                    onChange={HandleChange}
                                    value={dadosAdmin?.numeroAgente || ''}
                                />

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Box className={classes.sectionTitle}>Informações Complementares</Box>
                <Grid container className={classes.root}>
                    <Grid xs={12} md={4} item className={classes.gridItem}>
                        <TextField
                            type="text"
                            label="Gênero"
                            select
                            fullWidth
                            size="small"
                            name="genero"
                            variant="outlined"
                            onChange={HandleChange}
                            value={dadosAdmin?.genero || ''}
                            className={classes.textField}
                        >
                            <MenuItem value={'M'}>
                                Masculino
                            </MenuItem>
                            <MenuItem value={'F'}>
                                Feminino
                            </MenuItem>
                        </TextField>
                    </Grid>

                    <Grid xs={12} md={4} item className={classes.gridItem}>
                        <TextField
                            fullWidth
                            label="Data de Nascimento"
                            type="date"
                            size="small"
                            name="dataNascimento"
                            variant="outlined"
                            onChange={HandleChange}
                            value={dadosAdmin?.dataNascimento || ''}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>

                    <Grid xs={12} md={4} item className={classes.gridItem}>
                        <TextField
                            type="text"
                            label="Estado Civil"
                            select
                            fullWidth
                            size="small"
                            name="estadoCivil"
                            variant="outlined"
                            onChange={HandleChange}
                            value={dadosAdmin?.estadoCivil || ''}
                            className={classes.textField}
                        >
                            <MenuItem value="Solteiro(a)">
                                Solteiro(a)
                            </MenuItem>
                            <MenuItem value="Casado(a)">
                                Casado(a)
                            </MenuItem>
                            <MenuItem value="Divorciado(a)">
                                Divorciado(a)
                            </MenuItem>
                            <MenuItem value="Viúvo(a)">
                                Viúvo(a)
                            </MenuItem>
                        </TextField>
                    </Grid>
                </Grid>


                <Box className={classes.sectionTitle}>Contatos</Box>
                <Grid container className={classes.root}>
                    <Grid xs={12} md={4} item className={classes.gridItem}>
                        <TextField
                            type="text"
                            required
                            label="Telefone 1"
                            fullWidth
                            size="small"
                            name="tel1"
                            variant="outlined"
                            onChange={HandleChange}
                            value={dadosAdmin?.tel1 || ''}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>

                    <Grid xs={12} md={4} item className={classes.gridItem}>
                        <TextField
                            type="text"
                            label="Telefone 2"
                            fullWidth
                            size="small"
                            name="tel2"
                            variant="outlined"
                            onChange={HandleChange}
                            value={dadosAdmin?.tel2 || ''}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>

                    <Grid xs={12} md={4} item className={classes.gridItem}>
                        <TextField
                            type="email"
                            required
                            label="Email"
                            fullWidth
                            size="small"
                            name="email"
                            variant="outlined"
                            onChange={HandleChange}
                            value={dadosAdmin?.email || ''}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                </Grid>


                <Box className={classes.sectionTitle}>Localização</Box>

                <Grid container className={classes.root}>
                    <Grid xs={12} md={6} item className={classes.gridItem}>
                        <TextField
                            required
                            type="text"
                            label="Província"
                            select
                            fullWidth
                            size="small"
                            name="provincia"
                            variant="outlined"
                            onChange={HandleChange}
                            value={dadosAdmin?.provincia || ''}
                            className={classes.textField}
                        >
                            {provincias?.map((provincia) => (
                                <MenuItem key={provincia._id} value={provincia}>
                                    {provincia.designacao}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid xs={12} md={6} item className={classes.gridItem}>
                        <TextField
                            required
                            type="text"
                            label="Município"
                            select
                            fullWidth
                            size="small"
                            name="municipio"
                            variant="outlined"
                            onChange={HandleChange}
                            value={dadosAdmin?.municipio || ''}
                            className={classes.textField}
                        >
                            {municipios?.map((municipio) => (
                                <MenuItem key={municipio._id} value={municipio}>
                                    {municipio.designacao}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid xs={12} md={6} item className={classes.gridItem}>
                        <TextField
                            required
                            type="text"
                            label="Bairro"
                            fullWidth
                            size="small"
                            name="bairro"
                            variant="outlined"
                            onChange={HandleChange}
                            value={dadosAdmin?.bairro || ''}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>

                    <Grid xs={12} md={6} item className={classes.gridItem}>
                        <TextField
                            required
                            type="text"
                            label="Rua"
                            fullWidth
                            size="small"
                            name="rua"
                            variant="outlined"
                            onChange={HandleChange}
                            value={dadosAdmin?.rua || ''}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                </Grid>

                <ButtonLeft funcao={createAdmin} title={'Cadastrar'} disabled={!dadosAdmin.nome} load={load} />

            </Card>

        </Container>
    )
}
